import { Component, Input, OnInit } from "@angular/core";
import { IPerson, PersonUtility } from "../../interfaces";

/**
 * Shows persons.
 */
@Component({
    selector: "circ-person",
    templateUrl: "./person.component.html",
    styleUrls: ["./person.component.scss"],
    standalone: false
})
export class PersonComponent implements OnInit {
  public imageSrc: string;
  public initials: string;

  /** The person to show. */
  @Input() public person: IPerson;
  /** true, if image should be shown. Default: true */
  @Input() public showImage = true;
  /** true, if login should be shown. Default: false */
  @Input() public showLogin = false;
  /** true, if name should be shown. Default: true */
  @Input() public showName = true;
  @Input() public fontSize = 20;

  public getInitials(person: IPerson): string {
    return PersonUtility.initials(person);
  }

  public ngOnInit(): void {
    // Prevent empty fields
    if (!this.showName) {
      this.showImage = true;
    }
  }

  public getDisplayTitle(person: IPerson): string {
    return PersonUtility.displayTitle(person);
  }
}
